export enum StorageKeys {
  AccessTokenId = '$LoopBack$accessTokenId',
  CurrentUserId = '$LoopBack$currentUserId',
  RememberMe = '$LoopBack$rememberMe',
  ApolloSession = '[session]apolloSession',
  LocalPreviewExpanded = 'self-video-expanded',
  CallHasSeenSidebarPopover = '[call]hasSeenSidebarPopover',
  GroupCallGalleryView = '[groupCall]galleryView',
  InviteViaEmailTab = '[dashboard]inviteViaEmailTab',
  GPUData = 'gpuData',
  ResetPasswordToken = 'auth.reset-password.token',
  SignInEmailAddress = 'signInEmailAddress',
  HasSeenAppsPopover = 'hasSeenAppsPopover',
  VirtualBackgroundEffect = 'background-effect',
  FronteggLanguage = 'frontegg-language',
  FronteggAfterAuthRedirectUrl = 'FRONTEGG_AFTER_AUTH_REDIRECT_URL',
  PreferredLocale = '[locale]preferredLocale',
  SelectedPlanType = '[signup]selectedPlanType',
  SelectedPlanPeriod = 'typeFromPricingPage',
  DashboardSidebarCollapsed = '[dashboard]sidebarCollapsed',
  NoTrial = '[signup]noTrial',
  PromoCode = '[signup]promoCode',
  VersionNotificationDismissedAt = '[versioning]notificationDismissedAt',
  DashboardWaitingRoomSortOrder = '[dashboard]waitingRoomSortOrder',
  RoomFilterAlertDismissed = '[dashboard]roomFilterAlertDismissed',
  BaaIndividualAlertDismissed = '[baa]individualAlertDismissed',
  BaaTenantAlertDismissed = '[baa]tenantAlertDismissed',
}
